import { Media } from '#types/generated/graphql-types';
import isUpcomingEvent from '#utils/livestream/isUpcoming';
import hasEventDates from '#utils/livestream/hasEventDates';

const getCalendarFileUrl = (baseUrl: string, locale: string, media: Media) => {
  return (
    (isUpcomingEvent(media) &&
      hasEventDates(media) &&
      `${baseUrl}/api/events/${locale}/livestream/${media?.slug}`) ||
    ''
  );
};

export default getCalendarFileUrl;
